<body [ngClass]="{'backdrop': hidden}" (click)="hidden = false">

</body>

<!--Navbar-->
<nav class="navbar sticky-top flex-md-nowrap" [ngClass]="{'sidebar-sticky_hide ': hidden}">

  <div class="d-md-block nav-buffer" [ngClass]="{'close-sidebar': status}"></div>

  <button class="navbar-toggler position-absolute d-md-none collapsed" type="button" data-toggle="collapse"
    data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"><i class="bi bi-list"></i></span>
  </button>
  


    <div class="input-group" *ngIf="currentRoute != '/files'">
    <!-- *ngIf="currentRoute != '/files'" -->
      <div class="input-group-text search">

        <!-- <i class="bi bi-search"></i> -->
        <!-- <i class="bi serch-icon"><img class="th-icon" src="/assets/images/icons/closed-page-layout/search.svg"></i> -->
        <svg-icon src="/assets/images/icons/closed-page-layout/search.svg" class="serch-icon" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>

        <form class="form d-flex " #f="ngForm" [formGroup]="form" autocomplete="off">

          <input formControlName="search" class="form-control product" type="text" placeholder="{{ 'GLOBAL_SEARCH' | translate }}" aria-label="Search" (keydown.delete)="onClear()">
          <button class="clear" *ngIf="form.get('search').value.length > 0"  (click)="onClear()"><i class="bi bi-x-lg"></i></button>
          
          <div class="searchRes" [ngClass]="{'close-searchbar': searchStatus}">

            <div *ngIf="searchRes.length > 0">

              <ul *ngFor="let product of searchRes">

                <li>
                  <span routerLink="/products/profile/{{ product.id }}" placement="top">
                    {{product.name}}
                  </span>
                </li>
                <!-- <div *ngFor="let res of products.attributes">

                  <li *ngIf="res.name == 'Наименование товара'">
                    <span routerLink="/products/profile/{{ products.product_id }}" placement="top">
                      {{res.value}}
                    </span>
                  </li>
                </div> -->
              </ul>


            </div>

            <div *ngIf="searchRes == null" class="not-found-data">
              <span> По вашему запросу ничего не найдено</span>
            </div>

         
            <!-- <div class="not_fount d-flex mt-2">
              <span *ngIf="form.searchRes < 0 && searchRes.length == 0" class="serch_not">Товары не найдены</span>
            </div> -->
          </div>



            <!-- <div class="searchRes" [ngClass]="{'close-searchbar': searchStatus}">
              <ul *ngFor="let products of searchRes">
                <div *ngFor="let res of products.attributes">

                  <li *ngIf="res.name == 'Наименование товара'">
                    <span routerLink="/products/profile/{{ products.product_id }}" placement="top">
                      {{res.value}}
                    </span>
                  </li>
                </div>
              </ul>
              <div class="not_fount d-flex mt-2">
                <span *ngIf="form.searchRes < 0 && searchRes.length == 0" class="serch_not">Товары не найдены</span>
              </div>
            </div> -->


        </form>

      </div>

  </div>

  <div class="input-group"  *ngIf="currentRoute == '/files'">
  <!-- <div class="row filter-row"  *ngIf="currentRoute == '/files'"> -->

      <div class="input-group-text search">

        <!-- <i class="bi bi-search align-self-center"></i> -->
        <!-- <i class="bi serch-icon"><img class="th-icon" src="/assets/images/icons/closed-page-layout/search.svg"></i> -->
        <svg-icon src="/assets/images/icons/closed-page-layout/search.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
        

        <form class="form" #f="ngForm" [formGroup]="fileSearchform" autocomplete="off">

          <!-- <div class="row"> -->

              <!-- <div class="col-2 form-group">
                <ng-select 
                id="attribute_id" 
                class="custom" 
                clearAllText="{{ 'CLEAN' | translate }}" 
                notFoundText="{{ 'NO_DATA' | translate }}" 
                bindValue="id"
                bindLabel="name"
                formControlName="attribute_id" 
                [multiple]="false" 
                [items]="fileAttributes"
                groupBy="attribute_group_name" 
                appendTo="body"
                [selectOnTab]="true">
                    <ng-template ng-option-tmp let-item="item">
                        <div title="{{item.name}}">{{item.name}}</div>
                    </ng-template>
                </ng-select>
              </div> -->

              <div >

                <!-- <input *ngIf="fileSearchform.get('attribute_id').value == 'name'" formControlName="value" class="form-control" type="text" placeholder="{{ 'GLOBAL_SEARCH' | translate }}" aria-label="Search"> -->
                <!-- <input *ngIf="fileSearchform.get('filter_type').value == 'binding_value'" formControlName="search" class="form-control" type="number" placeholder="{{ 'GLOBAL_SEARCH' | translate }}" aria-label="Search"> -->
                <!-- *ngIf="fileSearchform.get('attribute_id').value == 'binding_value'" -->
                <!-- <tag-input
                (keypress)="numberOnly($event)"
                formControlName="value" 
                [modelAsStrings]="true"
                placeholder="{{ 'ADD_VALUE' | translate }}" 
                secondaryPlaceholder="{{ 'INTER_VALUE' | translate }}"
                addOnBlur="true" 
                addOnPaste="true"
                [pasteSplitPattern]=splitPattern
                >
                </tag-input> -->

                <input formControlName="values" class="form-control product" type="text" placeholder="Поиск" aria-label="Search" (keydown.delete)="onClear()">
                <button class="clear" *ngIf="fileSearchform.get('values').length > 0" (click)="onClear()"><i class="bi bi-x-lg"></i></button>
                
                <!-- <div class="fileListData" [ngClass]="{'close-searchbar': searchStatus}">
                  <ul *ngFor="let file of fileListData">
                      <li *ngIf="file.name == 'Наименование файла'">
                        <span routerLink="/files/edit/{{ file.id }}" placement="top">
                          {{file.name}}
                        </span>
                      </li>
                  </ul>
                </div> -->



                <div *ngIf="fileListData != null" class="searchResFile searchRes" [ngClass]="{'close-searchbar': searchStatus}">

                    <ul *ngFor="let file of fileListData">
                      <li>
                        <span (click)="getProfile(file.id)" placement="top">
                          {{file.name}}
                        </span>
                      </li>
                    </ul>
                  
                </div>

                <div *ngIf="fileListData == null" class="not-found-data">
                  <span> По вашему запросу ничего не найдено</span>
                </div>

              </div>

              <!-- <div class="col-1">
                <button type="button" class="btn btn-primary btn-sm btn-search" (click)="getFilterData()" [disabled]="form.invalid">
                  <i class="bi bi-search"></i>  Найти
              </button>
              </div> -->

            <!-- </div> -->


          </form>

      </div>

  </div>
    
    <div class="tools tools-format">
      <!-- Language -->
      <!-- <div class="mr-3" display="dynamic" ngbDropdown>
       <button type="button" class="btn dropdown-toggle btn-language" ngbDropdownToggle>
           <i class="bi bi-globe2"></i>
       </button>
       <div ngbDropdownMenu>
           <button ngbDropdownItem *ngFor="let lang of languages" [ngClass]="{'active': language == lang.code2}" (click)="selectLanguage(lang.code2)">{{ lang.value }}</button>
       </div>
     </div> -->
   
     <!-- NOTIFICATIONS -->
     <div class="dropleft notofications-menu notification-btn">
       <button type="button" class="btn btn-notifications" placement="left" tooltipClass="clue-name" ngbTooltip="Уведомления" data-toggle="dropdown" (click)="hidden = true; $event.stopPropagation()" aria-haspopup="true" aria-expanded="false">
         <!-- <i class="bi bi-bell"></i> -->
         <svg-icon src="/assets/images/icons/closed-page-layout/notfication.svg" [stretch]="true"
         [svgStyle]="{'width.px':24, 'margin-left.px':25, 'height.px':24}"></svg-icon>
         <span *ngIf="notifications.length > 0"
           class="badge badge-danger rounded-pill border border-light position-absolute">{{notifications.length}}</span>
       </button>
       <div class="dropdown-menu notifications">
         <div class="notifications-header">{{ 'NOTICE' | translate }}</div>
         <div class="notifications-item" *ngFor="let notification of notifications">
           <!-- <div class="notifications-item-date">{{notification.create_date}}</div> -->
           <!-- <div class="notification-item-title">{{ notification.notification_type_name }}</div> -->
           <div class="notifications-item-text">
             {{notification.title}}
             <a class="notifications-item-link" routerLink="/notifications/profile/{{notification.id}}" (click)="hidden = false"> Прочесть</a>
           </div>
         </div>
         <div class="notifications-empty" *ngIf="notifications.length == 0">{{ 'NOTIFICATION.NO_NOTIFICATIONS' | translate }}</div>
         <div class="notifications-tools">
           <button class="btn btn-none btn-light btn-sm" (click)="hidden = false">{{ 'CLOSE' | translate }}</button>
         </div>
       </div>
     </div>
    </div>
</nav>

<!-- HIDE/EXPAND SIDEBAR BUTTON -->
<div class="sidebar-button" [ngClass]="{'close-sidebar': status}" *ngIf="!visibility()">
  <div class="btn-expand" type="button" (click)="toggleSidebar()">
    <!-- <i class="bi bi-chevron-left" src="/assets/images/articool.svg"></i> -->
    <svg-icon src="/assets/images/icons/closed-page-layout/chevron.svg" [stretch]="true"
    [svgStyle]="{'width.px':16, 'height.px':16, 'margin-bottom.px':4 }"></svg-icon>
  </div>
</div>

<div class="container-fluid">
  
  <div class="row">

    <!--Sidebar-->
    <nav id="sidebarMenu" class="d-md-block collapse sidebar" [ngClass]="{'close-sidebar': status}">

      <div class="sidebar-sticky">

        <div class="title" [ngClass]="{'close-sidebar': status}">
          <div class="logo">
            <img src="/assets/images/articool.svg" alt="{{ 'COMPANY.LOGO' | translate }}">
          </div>
          <div class="text">
            {{ 'COMPANY.NAME' | translate }}
          </div>
        </div>

        <div class="user-info_inner"  *ngIf="!visibility()">

          <div *ngIf="user" class="user-info" [ngClass]="{'close-sidebar': status}">
              <div *ngIf="status" class="user-photo-box close-sidebar" placement="right" tooltipClass="clue-name" ngbTooltip="{{ user.second_name }} {{ user.first_name }} {{ user.email }}" container="body">
                <!-- <a routerLink="/users/profile" (click)="toggleSidebar(false)"> -->
                <a routerLink="/users/edit/{{ user.id }}" (click)="toggleSidebar(false)">
                  <div class="user-photo" [ngClass]="{'close-sidebar': status}">
                    <img [ngClass]="{'close-sidebar': status}" *ngIf="avatar" src="{{avatar}}">
                    <img [ngClass]="{'close-sidebar': status}" *ngIf="!avatar" src="/assets/images/no-avatar.png">
                  </div>
                </a>
              </div>
            <div class="user-photo-box" *ngIf="!status">
              <a routerLink="/users/edit/{{ user.id }}" (click)="toggleSidebar(false)">
              <!-- <a routerLink="/users/profile" (click)="toggleSidebar(false)"> -->
                <div class="user-photo">
                  <img *ngIf="avatar" src="{{avatar}}">
                  <img *ngIf="!avatar" src="/assets/images/no-avatar.png">
                </div>
              </a>
            </div>
            <div class="user-fio-box" *ngIf="!status">
              <a routerLink="/users/edit/{{ user.id }}" (click)="toggleSidebar(false)">
              <!-- <a routerLink="/users/profile" (click)="toggleSidebar(false)"> -->
                <div *ngIf="user" class="user-fio">
                  {{ user.second_name }} {{ user.first_name }}
                </div>
                <div *ngIf="user" class="user-email">
                  <span *ngIf="user.email">{{ user.email }}</span>
                </div>
              </a>

              <div *ngIf="organization" class="user-org-select">

                <div ngbDropdown class="dropdown d-inline-block" container="body">
                  <div ngbDropdownToggle>
                    {{ 'ORGANIZATION.BIN' | translate }} {{ organization.ident_num }}
                    <svg-icon class="icon-dropdown" src="/assets/images/icons/closed-page-layout/arrow-down.svg" [stretch]="true"
                    [svgStyle]="{'width.px':16, 'height.px':16}"></svg-icon>
                  </div>
                  <div ngbDropdownMenu class="org-menu dropdown-menu-open">
                    <div ngbDropdownItem class="org-menu-list-item" placement="right" tooltipClass="clue-name" container="body" ngbTooltip="{{ org.name }}"
                      *ngFor="let org of organizations" (click)="changeDefaultOrganization(org.id)">
                      {{ 'ORGANIZATION.BIN' | translate }} {{ org.ident_num }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="user-fio-box" *ngIf="organization && status">
              <div ngbDropdown class="dropdown user-fio-box_close d-inline-block" placement="right" tooltipClass="clue-name" ngbTooltip="{{organization.name}}"  container="body">
                <div ngbDropdownToggle>
                  <svg-icon src="/assets/images/icons/closed-page-layout/arrow-down.svg" [stretch]="true"
                  [svgStyle]="{'width.px':16, 'height.px':16}"></svg-icon>
                </div>
                <div ngbDropdownMenu class="org-menu dropdown-menu-close">
                  <div ngbDropdownItem class="org-menu-list-item" placement="right" tooltipClass="clue-name" container="body" ngbTooltip="{{ org.name }}"
                    *ngFor="let org of organizations" (click)="changeDefaultOrganization(org.id)">
                    {{ 'ORGANIZATION.BIN' | translate }} {{ org.ident_num }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ul class="nav flex-column left-menu close-sidebar" *ngIf="status">
            <!-- <li class="nav-item">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('dashboard')}" routerLink="/dashboard">
                <i class="bi bi-clipboard"></i><span> Дашборд</span>
              </a>
            </li> -->
            <li class="nav-item  icon" *ngIf="checkUserRole()">
              <a class="nav-link close-sidebar  m-0" [ngClass]="{'active': checkActiveMenu('products')}" routerLink="/products" (click)="onSidebarNavClick('/products', $event)" placement="right" tooltipClass="clue-name" ngbTooltip="{{ 'CATALOG' | translate }}" container="body">
                <svg-icon class="icon" src="/assets/images/icons/closed-page-layout/catalog.svg" [stretch]="true"
                [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
              </a>
            </li>
            <li class="nav-item  icon" *ngIf="permissionService.check('ORGANIZATION_LIST') && checkUserRole()">
              <a class="nav-link close-sidebar" [ngClass]="{'active': checkActiveMenu('organizations')}" routerLink="/organizations" placement="right" tooltipClass="clue-name" ngbTooltip="{{ 'ORGANIZATION.USER_ORG_ROLES.ORGANIZATION' | translate }}" container="body">
                <svg-icon class="icon"src="/assets/images/icons/closed-page-layout/organization.svg" [stretch]="true"
                [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
              </a>
            </li>
            <li class="nav-item  icon" *ngIf="checkUserRole()">
              <a class="nav-link close-sidebar" [ngClass]="{'active': checkActiveMenu('files')}" routerLink="/files" (click)="onSidebarNavClick('/files', $event)" placement="right" tooltipClass="clue-name" ngbTooltip="{{ 'FILES.FILES' | translate }}" container="body"
                *ngIf="user && user.roles[0].id != '344bb204-2907-4576-b8ce-1e230d790b68'">
                <!-- <i class="bi bi-inboxes"></i> --> 
                <svg-icon class="icon" src="/assets/images/icons/closed-page-layout/files.svg" [stretch]="true"
                [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
              </a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('tasks')}" routerLink="/tasks">
                <i class="bi bi-clock"></i><span> Задачи</span>
              </a>
            </li> -->
            
            <li class="nav-item  icon">
            <!-- <li class="nav-item" *ngIf="permissionService.check('USER_NOTIFICATIONS_LIST')"> -->
              <a class="nav-link close-sidebar" [ngClass]="{'active': checkActiveMenu('notifications')}" routerLink="/notifications" placement="right" tooltipClass="clue-name" ngbTooltip="{{ 'NOTICE' | translate }}" container="body">
                <!-- <i class="bi bi-bell"></i> -->
                <svg-icon class="icon" src="/assets/images/icons/closed-page-layout/notfication.svg" [stretch]="true"
                [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
              </a>
            </li>
            

            <!-- <li class="nav-item" *ngIf="permissionService.check('KASPI_PRICE_LIST')">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('export')}" routerLink="/export"
                *ngIf="user && user.roles[0].id != '344bb204-2907-4576-b8ce-1e230d790b68'">
                <i class="bi bi-download"></i><span> {{ 'IMPORT_AND_EXPORT.EXPORT' | translate }}</span>
              </a>
            </li> -->
            
            <li class="nav-item  icon" *ngIf="permissionService.check('ATTRIBUTES_MAPPING_LIST') || permissionService.check('ATTRIBUTES_MAPPING_CREATE') || permissionService.check('IMPORT_FILE') && checkUserRole()">
            <!-- <li class="nav-item" *ngIf="permissionService.check('ATTRIBUTES_MAPPING_LIST')"> -->
              <a class="nav-link close-sidebar" [ngClass]="{'active': checkActiveMenu('import')}" routerLink="/import" placement="right" tooltipClass="clue-name" ngbTooltip="{{ 'IMPORT_AND_EXPORT.IMPORT' | translate }}" container="body"
                *ngIf="user && user.roles[0].id != '344bb204-2907-4576-b8ce-1e230d790b68'">
                <!-- <i class="bi bi-upload"></i> -->
                <svg-icon class="icon" src="/assets/images/icons/closed-page-layout/import.svg" [stretch]="true"
                [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
              </a>
            </li>
          

            <!-- <li class="nav-item" *ngIf="permissionService.check('NPC_API_KEYS_LIST')">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('integration')}" routerLink="/integration"
                *ngIf="user && user.roles[0].id != '344bb204-2907-4576-b8ce-1e230d790b68'">
                <i class="bi bi-code-square"></i><span> {{ 'INTEGRATION.INTEGRATION' | translate }}</span>
              </a>
            </li> -->
          </ul>

          <ul class="nav flex-column left-menu" *ngIf="!status">
            <!-- <li class="nav-item">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('dashboard')}" routerLink="/dashboard">
                <i class="bi bi-clipboard"></i><span> Дашборд</span>
              </a>
            </li> -->
            <li class="nav-item icon" *ngIf="checkUserRole()">
              
            <!-- <li class="nav-item" *ngIf="permissionService.check('PRODUCT_LIST')"> -->
              <a class="nav-link  m-0" [ngClass]="{'active': checkActiveMenu('products')}" routerLink="/products" (click)="onSidebarNavClick('/products', $event)">
                <!-- <i class="bi bi-folder"></i> -->
                <!-- <div class="icon"> -->
                <!-- </div> -->
                <svg-icon class="icon" src="/assets/images/icons/closed-page-layout/catalog.svg" [stretch]="true"
                [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
                <span> {{ 'CATALOG' | translate }}</span>
              </a>
            </li>
            <li class="nav-item icon" *ngIf="permissionService.check('ORGANIZATION_LIST') && checkUserRole()">
            <!-- <li class="nav-item" *ngIf="permissionService.check('ORGANIZATION_LIST')"> -->
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('organizations')}" routerLink="/organizations">
                <!-- <i class="bi bi-building"></i> -->
                <svg-icon class="icon"src="/assets/images/icons/closed-page-layout/organization.svg" [stretch]="true"
                [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
                <span> {{ 'ORGANIZATION.USER_ORG_ROLES.ORGANIZATION' | translate }}</span>
              </a>
            </li>
            <li class="nav-item icon" *ngIf="checkUserRole()">
            <!-- <li class="nav-item" *ngIf="permissionService.check('ORGS_FILES_LIST')"> -->
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('files')}" routerLink="/files" (click)="onSidebarNavClick('/files', $event)"
                *ngIf="user && user.roles[0].id != '344bb204-2907-4576-b8ce-1e230d790b68'">
                <!-- <i class="bi bi-inboxes"></i> --> 
                <svg-icon class="icon" src="/assets/images/icons/closed-page-layout/files.svg" [stretch]="true"
                [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
                <span> {{ 'FILES.FILES' | translate }}</span>
              </a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('tasks')}" routerLink="/tasks">
                <i class="bi bi-clock"></i><span> Задачи</span>
              </a>
            </li> -->
            
            <li class="nav-item icon">
            <!-- <li class="nav-item" *ngIf="permissionService.check('USER_NOTIFICATIONS_LIST')"> -->
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('notifications')}" routerLink="/notifications">
                <!-- <i class="bi bi-bell"></i> -->
                <svg-icon class="icon" src="/assets/images/icons/closed-page-layout/notfication.svg" [stretch]="true"
                [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
                <span> {{ 'NOTICE' | translate }}</span>
              </a>
            </li>
            

            <!-- <li class="nav-item" *ngIf="permissionService.check('KASPI_PRICE_LIST')">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('export')}" routerLink="/export"
                *ngIf="user && user.roles[0].id != '344bb204-2907-4576-b8ce-1e230d790b68'">
                <i class="bi bi-download"></i><span> {{ 'IMPORT_AND_EXPORT.EXPORT' | translate }}</span>
              </a>
            </li> -->
            
            <!-- <li class="nav-item icon" *ngIf="permissionService.check('ATTRIBUTES_MAPPING_LIST') && checkUserRole()"> -->
            <li class="nav-item" *ngIf="permissionService.check('ATTRIBUTES_MAPPING_LIST') || permissionService.check('ATTRIBUTES_MAPPING_CREATE') || permissionService.check('IMPORT_FILE')">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('import')}" routerLink="/import"
                *ngIf="user && user.roles[0].id != '344bb204-2907-4576-b8ce-1e230d790b68'">
                <!-- <i class="bi bi-upload"></i> -->
                <svg-icon class="icon" src="/assets/images/icons/closed-page-layout/import.svg" [stretch]="true"
                [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
                <span> {{ 'IMPORT_AND_EXPORT.IMPORT' | translate }}</span>
              </a>
            </li>
          

            <!-- <li class="nav-item" *ngIf="permissionService.check('NPC_API_KEYS_LIST')">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('integration')}" routerLink="/integration"
                *ngIf="user && user.roles[0].id != '344bb204-2907-4576-b8ce-1e230d790b68'">
                <i class="bi bi-code-square"></i><span> {{ 'INTEGRATION.INTEGRATION' | translate }}</span>
              </a>
            </li> -->
          </ul>

          <div class="left-menu_line"></div>
          
          <ul class="nav flex-column left-menu  m-0" *ngIf="status">
            <!-- <li class="nav-item" *ngIf="permissionService.check('UROLES_IN_ORGS_LIST')"> -->
            <li class="nav-item icon" *ngIf="checkUserRole()">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('settings')}" routerLink="/settings" (click)="onSidebarNavClick('/settings', $event)" placement="right" tooltipClass="clue-name" ngbTooltip="{{ 'MENU_SIDEBAR.SETTINGS' | translate }}" container="body">
                <!-- <i class="bi bi-gear"></i>  --> 
                <svg-icon class="icon" src="/assets/images/icons/closed-page-layout/setting.svg" [stretch]="true"
                [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
              </a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('info')}" routerLink="/info">
                <i class="bi bi-info-circle"></i> <span> Информация</span>
              </a>
            </li> -->
          </ul>

          <ul class="nav flex-column left-menu  m-0" *ngIf="!status">
            <!-- <li class="nav-item" *ngIf="permissionService.check('UROLES_IN_ORGS_LIST')"> -->
            <li class="nav-item icon" *ngIf="checkUserRole()">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('settings')}" routerLink="/settings" (click)="onSidebarNavClick('/settings', $event)">
                <!-- <i class="bi bi-gear"></i>  --> 
                <svg-icon class="icon" src="/assets/images/icons/closed-page-layout/setting.svg" [stretch]="true"
                [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
                <span> {{ 'MENU_SIDEBAR.SETTINGS' | translate }}</span>
              </a>
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" [ngClass]="{'active': checkActiveMenu('info')}" routerLink="/info">
                <i class="bi bi-info-circle"></i> <span> Информация</span>
              </a>
            </li> -->
          </ul>

        </div>

        <div *ngIf="visibility()">

          <div class="user-profile-info">
            <div class="user-profile-photo">
              <img *ngIf="avatar" src="{{avatar}}">
              <img *ngIf="!avatar" src="/assets/images/no-avatar.png">
            </div>
            <div *ngIf="user" class="user-profile-fio">
              {{ user.second_name }} {{ user.first_name }}
            </div>
            <div *ngIf="user" class="user-profile-position">
              -
            </div>
            <div *ngIf="user && organization" class="user-profile-org">
              {{ organization.name }}
            </div>
          </div>

          <div *ngIf="user" class="user-profile-contacts">
            <div class="contact-title">
              {{ 'CONTACTS' | translate }}
            </div>
            <div class="contact-content">
              <div *ngIf="user.email"><i class="bi bi-at"></i> {{ user.email }}</div>
              <div *ngIf="user.phone"><i class="bi bi-telephone"></i> {{ user.phone }}</div>
            </div>
          </div>

        </div>

      </div>
      <div class="sidebar-footer">

        
        <ul class="nav flex-column nav-logout" *ngIf="status">
          <li class="nav-item icon-logout">
            <a class="nav-link btn-logout" (click)="logout()" placement="right" tooltipClass="clue-name" ngbTooltip="{{ 'LOGOUT' | translate }}" container="body">
              <!-- <i class="bi bi-box-arrow-right"></i> -->
              <svg-icon src="/assets/images/icons/closed-page-layout/log-out.svg" [stretch]="true"
              [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
            </a>
          </li>
        </ul>

        <ul class="nav flex-column nav-logout" *ngIf="!status">
          <li class="nav-item icon-logout">
            <a class="nav-link btn-logout" (click)="logout()">
              <!-- <i class="bi bi-box-arrow-right"></i> -->
              <svg-icon src="/assets/images/icons/closed-page-layout/log-out.svg" [stretch]="true"
              [svgStyle]="{'width.px':22, 'height.px':22}"></svg-icon>
              <span> {{ 'LOGOUT' | translate }}</span>
            </a>
          </li>
        </ul>


        <!-- <div *ngIf="!visibility()" class="btn-for-common">

          <ul class="nav-logout flex-column" [ngClass]="{'close-sidebar': status}">
            <li class="nav-item">
                <a class="nav-link btn-logout" (click)="logout()">
                  <i class="bi bi-box-arrow-right"></i> <span> {{ 'LOGOUT' | translate }}</span>
                </a>
              </li>
          </ul>

        </div> -->

        <div *ngIf="visibility() && user" class="btn-for-profile">
          <button type="button" class="btn btn-outline-dark btn-sm" routerLink="/products">{{ 'CLOSE' | translate }}</button>
          <button type="button" class="btn btn-primary btn-sm"
            routerLink="/users/edit/{{ user.id }}">{{ 'EDIT' | translate }}</button>
        </div>

      </div>
    </nav>

    <!--Content-->
    <main role="main" class="ml-sm-auto main-container" [ngClass]="{'close-sidebar': status}">
      <div class="container-fluid">
        <router-outlet></router-outlet>
      </div>
    </main>

    <!-- <div *ngIf="currentRoute != '/settings'" class="ml-sm-auto main-fotter" [ngClass]="{'close-sidebar': status}">
      <div class="pagination-component">
          <app-pagination></app-pagination>
      </div>
    </div> -->

  </div>

</div>